import React from 'react';
import { useCarousel } from '../common/landingHooks';

const ChevronL = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>;
const ChevronR = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6" /></svg>;

const QUOTES = [
    { q: 'You could walk into any assignment and start at 60% instead of zero.', a: 'RD, Fractional CFO' },
    { q: "Putting a deal in front of a VC, you've answered 60 questions they didn't even ask yet.", a: 'CL, Fractional CFO' },
    { q: "It amplifies my ability to show value — without the client even realising how much I've leveraged the platform.", a: 'FR, Fractional CFO' },
    { q: 'What you want is every CFO to see what I saw.', a: 'JH, CFO Centre' },
    { q: 'It gives me a way to upsell into clients.', a: 'AW, Fractional CFO' },
    { q: 'Better organised businesses do better. Better organised businesses grow faster.', a: 'JC, Fractional CFO' },
    { q: "Lots of small companies don't know where their documents are — they're in the MD's email or his wife's recipe folder.", a: 'KT, Fractional CFO' },
];

const GLOWS = [
    { top: 6, left: '1597px', size: 480, c: 'rgba(252,119,133,0.42)' },
    { top: 254, left: '370px', size: 540, c: 'rgba(74,103,255,0.40)' },
    { top: 694, left: '-329px', size: 520, c: 'rgba(74,103,255,0.34)' },
    { top: 666, left: '2222px', size: 420, c: 'rgba(252,119,133,0.32)' },
];

const FractionalCarouselSection = () => {
    const { viewportRef, trackRef, page, pages, next, prev, goTo, pause, resume } = useCarousel(QUOTES.length, { autoplayMs: 5500 });

    return (
        <section id="quotes" className="lp-quotes">
            <div className="lp-quotes-bg" aria-hidden="true">
                {GLOWS.map((g, i) => (
                    <i key={i} style={{ top: g.top + 'px', left: g.left, width: g.size + 'px', height: g.size + 'px', background: `radial-gradient(circle, ${g.c}, ${g.c.replace(/[\d.]+\)$/, '0)')} 70%)`, filter: 'blur(78px)' }} />
                ))}
            </div>

            <div className="lp-sec-head">
                <h2 className="lp-h2" data-lp-reveal>CFOs who use it, swear by it.</h2>
                <div className="lp-arrows">
                    <button className="lp-arrow" aria-label="Previous quotes" onClick={prev}><ChevronL /></button>
                    <button className="lp-arrow" aria-label="Next quotes" onClick={next}><ChevronR /></button>
                </div>
            </div>

            <div className="lp-viewport" onMouseEnter={pause} onMouseLeave={resume}>
                <div className="lp-vp-inner" ref={viewportRef}>
                    <div className="lp-slide-anim">
                        <div className="lp-track" ref={trackRef}>
                            {QUOTES.map((item, i) => (
                                <figure className="lp-qcard" key={i} data-lp-reveal data-lp-delay={(i % 3) * 120}>
                                    <div className="mark">“</div>
                                    <blockquote>{item.q}</blockquote>
                                    <figcaption>{item.a}</figcaption>
                                </figure>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            <div className="lp-foot">
                <p data-lp-reveal>CFOs setting AI-augmented practice standards now will set the bar for the next five years.</p>
                <div className="lp-dots" style={{ margin: 0, padding: 0 }}>
                    {Array.from({ length: pages }).map((_, i) => (
                        <button key={i} className={`lp-dot ${i === page ? 'is-active' : ''}`} aria-label={`Go to slide ${i + 1}`} onClick={() => goTo(i)} />
                    ))}
                </div>
            </div>

            <div className="lp-container">
                <img className="lp-group-photo" data-lp-reveal src={require('../../../../images/landing-pages/fractional/fractional-carosuel.png')} alt="Fractional CFOs" />
            </div>
        </section>
    );
};

export default FractionalCarouselSection;
